export const DEFAULT_META = {
  title: 'Nykaa Fashion – Online Shopping of Clothes & Accessories from Top Designers',
  description:
    'Nykaa Fashion – Online Shopping Site for Designer Clothes, Accessories & Lifestyle Products in India. Shop at Best Prices &amp; Attractive Offers from India’s best Fashion Website.',
  keywords: 'online shopping, online shopping sites, online shopping websites, fashion',
};
